import { useState, useEffect } from "react";

const API_URL = "https://venci-backend-production.up.railway.app";

const C = {
  azul:      "#0F2A4D",
  azulClaro: "#173A66",
  verde:     "#3DAA8A",
  verdeDim:  "rgba(61,170,138,0.12)",
  blanco:    "#FFFFFF",
  grisAzul:  "#5B7088",
  bg:        "#F7F9FB",
  bgCard:    "#FFFFFF",
  border:    "#E2E8EF",
  ink:       "#16243A",
  inkDim:    "#8896A8",
  danger:    "#E0524E",
  dangerBg:  "rgba(224,82,78,0.08)",
};

// Mensajes que replican exactamente las piezas de campaña de VenciApp —
// conectan el Login con la misma identidad que se ve en redes, en lugar
// de inventar un mensaje distinto solo para esta pantalla.
const MENSAJES = [
  { eyebrow: "AHORRÁS TIEMPO · 01", t1: "Facturás en", t2: "segundos.", sub: "Cargás el PDF y VenciApp completa todo y emite la factura por vos.", badge: "De PDF a factura, automático" },
  { eyebrow: "MÁS PRECISIÓN · 02",  t1: "Cero errores de", t2: "tipeo.",  sub: "El sistema lee el comprobante y carga los datos exactos, siempre.", badge: "Datos exactos del comprobante" },
  { eyebrow: "100% OFICIAL · 03",   t1: "Directo y legal a", t2: "ARCA.", sub: "Cada factura se emite de forma oficial, sin pasos intermedios.", badge: "Emitida a ARCA en 1 clic" },
];

export default function Login({ onLogin }) {
  const tokenDeURL = new URLSearchParams(window.location.search).get("token");

  const [modo, setModo]       = useState(tokenDeURL ? "resetear" : "login");
  const [form, setForm]       = useState({ nombre:"", cuit:"", email:"", password:"", colegio:"", passwordNueva:"", passwordNuevaConfirmar:"" });
  const [cargando, setCargando] = useState(false);
  const [error, setError]     = useState(null);
  const [exito, setExito]     = useState(null);
  const [msgIdx, setMsgIdx]   = useState(0);
  const [fade, setFade]       = useState(true);

  // Rotación del mensaje de marca cada 5 segundos, con un fade suave —
  // un único momento orquestado en lugar de varias animaciones sueltas.
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setMsgIdx(i => (i + 1) % MENSAJES.length);
        setFade(true);
      }, 350);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const set = (k,v) => setForm(prev=>({...prev,[k]:v}));

  const inputStyle = {
    width:"100%", padding:"13px 15px", background:C.bg,
    border:`1.5px solid ${C.border}`, borderRadius:10, fontSize:14.5,
    color:C.ink, outline:"none", fontFamily:"'Inter',sans-serif",
    transition:"border-color 0.15s, box-shadow 0.15s",
  };

  const labelStyle = {
    fontSize:12.5, fontWeight:600, color:C.ink,
    marginBottom:7, display:"block"
  };

  const cambiarModo = (nuevoModo) => {
    setModo(nuevoModo);
    setError(null);
    setExito(null);
  };

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setExito(null);
    setCargando(true);

    try {
      if (modo === "login" || modo === "registro") {
        const endpoint = modo === "login" ? "/auth/login" : "/auth/registro";
        const body = modo === "login"
          ? { email: form.email, password: form.password }
          : form;

        const resp = await fetch(`${API_URL}${endpoint}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        });
        const data = await resp.json();

        if (data.ok) {
          localStorage.setItem("venci_token", data.data.token);
          localStorage.setItem("venci_contador", JSON.stringify(data.data.contador));
          onLogin(data.data.contador, data.data.token);
        } else {
          setError(data.error || "Algo salió mal");
        }
      }
      else if (modo === "olvide") {
        const resp = await fetch(`${API_URL}/auth/olvide-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: form.email })
        });
        const data = await resp.json();
        if (data.ok) {
          setExito("Si ese email está registrado, te llegó un link para restablecer tu contraseña. Revisá tu bandeja de entrada.");
        } else {
          setError(data.error || "Algo salió mal");
        }
      }
      else if (modo === "resetear") {
        if (form.passwordNueva !== form.passwordNuevaConfirmar) {
          setError("Las contraseñas no coinciden");
          setCargando(false);
          return;
        }
        const resp = await fetch(`${API_URL}/auth/resetear-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: tokenDeURL, password: form.passwordNueva })
        });
        const data = await resp.json();
        if (data.ok) {
          setExito("Contraseña actualizada correctamente. Ya podés iniciar sesión.");
          setTimeout(()=>{
            window.history.replaceState({}, "", "/");
            cambiarModo("login");
          }, 2000);
        } else {
          setError(data.error || "El link expiró o no es válido. Pedí uno nuevo.");
        }
      }
    } catch (err) {
      setError("No se pudo conectar con el servidor");
    } finally {
      setCargando(false);
    }
  };

  const titulos = {
    login:    { t:"VenciApp", s:"Ingresá a tu panel para seguir facturando" },
    registro: { t:"Creá tu cuenta",        s:"Empezá a automatizar tu facturación hoy" },
    olvide:   { t:"Recuperar contraseña",  s:"Te mandamos un link a tu email para restablecerla" },
    resetear: { t:"Elegí tu nueva contraseña", s:"Escribí una contraseña nueva para tu cuenta" },
  };

  const textoBoton = {
    login:    cargando ? "Ingresando..."     : "Iniciar sesión",
    registro: cargando ? "Creando cuenta..." : "Crear cuenta",
    olvide:   cargando ? "Enviando..."       : "Enviar link de recuperación",
    resetear: cargando ? "Guardando..."      : "Guardar nueva contraseña",
  };

  const msg = MENSAJES[msgIdx];

  return (
    <div style={{ minHeight:"100vh", display:"flex", fontFamily:"'Inter',sans-serif", background:C.bg }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@700;800&display=swap');
        *{box-sizing:border-box;}
        input:focus{border-color:${C.verde} !important; box-shadow:0 0 0 3px ${C.verdeDim};}
        @keyframes spin{to{transform:rotate(360deg)}}
        @keyframes fadeIn{from{opacity:0;transform:translateY(10px);}to{opacity:1;transform:translateY(0);}}
        .venci-display{font-family:'Poppins',sans-serif;}
        @media (max-width: 860px){
          .venci-panel-marca{display:none !important;}
        }
      `}</style>

      {/* PANEL IZQUIERDO — identidad de marca, replica las piezas de campaña */}
      <div className="venci-panel-marca" style={{
        flex:"0 0 46%", background:C.azul, position:"relative",
        display:"flex", flexDirection:"column", justifyContent:"center",
        padding:"60px 64px", overflow:"hidden", color:C.blanco,
      }}>
        {/* La diagonal verde — el elemento gráfico distintivo de las piezas */}
        <svg style={{position:"absolute", top:0, right:-2, height:"100%", width:90}} viewBox="0 0 90 800" preserveAspectRatio="none">
          <polygon points="40,0 90,0 90,800 0,800" fill={C.verde} opacity="1"/>
          <polygon points="20,0 60,0 60,800 0,800" fill={C.azul}/>
        </svg>

        <div style={{position:"relative", zIndex:2}}>
          <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:64}}>
            <img src="/VENCIApp.png" alt="Venci" style={{height:48,width:"auto",objectFit:"contain"}}
              onError={e=>{e.target.style.display="none";}}/>
          </div>

          <div style={{
            opacity: fade?1:0, transform: fade?"translateY(0)":"translateY(8px)",
            transition:"opacity 0.35s ease, transform 0.35s ease",
          }}>
            <div style={{fontSize:12, fontWeight:700, color:C.verde, letterSpacing:"0.12em", marginBottom:18}}>
              {msg.eyebrow}
            </div>
            <h1 className="venci-display" style={{fontSize:42, fontWeight:800, lineHeight:1.12, margin:0, marginBottom:20}}>
              {msg.t1}<br/>
              <span style={{color:C.verde}}>{msg.t2}</span><span style={{color:C.verde}}>.</span>
            </h1>
            <p style={{fontSize:16, color:"rgba(255,255,255,0.72)", lineHeight:1.6, maxWidth:380, marginBottom:28}}>
              {msg.sub}
            </p>
            <div style={{display:"inline-flex", alignItems:"center", gap:8, background:"rgba(61,170,138,0.16)", border:`1px solid ${C.verde}55`, borderRadius:30, padding:"9px 18px"}}>
              <span style={{width:18,height:18,borderRadius:"50%",background:C.verde,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,flexShrink:0}}>✓</span>
              <span style={{fontSize:13.5, fontWeight:600, color:C.blanco}}>{msg.badge}</span>
            </div>
          </div>

          {/* Indicador de los 3 mensajes */}
          <div style={{display:"flex", gap:6, marginTop:56}}>
            {MENSAJES.map((_,i)=>(
              <div key={i} style={{height:3, width:i===msgIdx?28:14, borderRadius:2, background:i===msgIdx?C.verde:"rgba(255,255,255,0.25)", transition:"all 0.3s"}}/>
            ))}
          </div>
        </div>
      </div>

      {/* PANEL DERECHO — formulario */}
      <div style={{flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"40px 24px"}}>
        <div style={{width:"100%", maxWidth:420, animation:"fadeIn 0.4s ease"}}>

          <div style={{textAlign:"center", marginBottom:32}}>
            <div style={{display:"flex",justifyContent:"center",marginBottom:16}}>
              <img src="/VENCIApp.png" alt="Venci" style={{height:162,width:"auto",objectFit:"contain"}}
                onError={e=>{e.target.style.display="none";}}/>
            </div>
            <h2 className="venci-display" style={{fontSize:25, fontWeight:800, color:C.ink, marginBottom:8}}>
              {titulos[modo].t}
            </h2>
            <div style={{fontSize:13.5, color:C.inkDim}}>
              {titulos[modo].s}
            </div>
          </div>

          {exito && (modo==="olvide" || modo==="resetear") ? (
            <div style={{background:C.verdeDim, border:`1px solid ${C.verde}44`, borderRadius:12, padding:"18px 20px", fontSize:13.5, color:C.azul, textAlign:"center", lineHeight:1.6}}>
              <div style={{width:36,height:36,borderRadius:"50%",background:C.verde,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,color:"#fff",margin:"0 auto 12px"}}>✓</div>
              {exito}
            </div>
          ) : (
            <form onSubmit={submit} style={{display:"flex", flexDirection:"column", gap:16}}>

              {modo === "registro" && (
                <>
                  <div>
                    <label style={labelStyle}>¿Cómo vas a usar Venci?</label>
                    <div style={{display:"flex",gap:8,marginTop:6}}>
                      {[
                        {v:"estudio", t:"Estudio contable", s:"Gestiono varios clientes"},
                        {v:"comercio", t:"Soy un comercio", s:"Me facturo a mí mismo"},
                      ].map(opt=>(
                        <div key={opt.v} onClick={()=>set("tipoCuenta", opt.v)}
                          style={{flex:1,padding:"12px 14px",border:`1.5px solid ${(form.tipoCuenta||"estudio")===opt.v?C.verde:C.border}`,borderRadius:10,cursor:"pointer",background:(form.tipoCuenta||"estudio")===opt.v?C.verdeDim:C.bg,transition:"all 0.15s"}}>
                          <div style={{fontSize:13,fontWeight:700,color:(form.tipoCuenta||"estudio")===opt.v?C.azul:C.ink,marginBottom:2}}>{opt.t}</div>
                          <div style={{fontSize:11,color:C.inkDim}}>{opt.s}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div>
                    <label style={labelStyle}>Nombre completo</label>
                    <input value={form.nombre} onChange={e=>set("nombre", e.target.value)}
                      placeholder="Tu nombre y apellido" style={inputStyle} required/>
                  </div>
                  <div>
                    <label style={labelStyle}>CUIT</label>
                    <input value={form.cuit} onChange={e=>set("cuit", e.target.value)}
                      placeholder="20-12345678-9" style={inputStyle} required/>
                  </div>
                  {(form.tipoCuenta||"estudio")==="estudio" ? (
                    <div>
                      <label style={labelStyle}>Colegio profesional (opcional)</label>
                      <input value={form.colegio} onChange={e=>set("colegio", e.target.value)}
                        placeholder="Ej: CPCECF 4821" style={inputStyle}/>
                    </div>
                  ) : (
                    <div>
                      <label style={labelStyle}>Categoría de Monotributo</label>
                      <select value={form.categoria||"A"} onChange={e=>set("categoria", e.target.value)}
                        style={{...inputStyle, cursor:"pointer"}}>
                        {["A","B","C","D","E","F","G","H","I","J","K"].map(c=>(
                          <option key={c} value={c}>Categoría {c}</option>
                        ))}
                      </select>
                    </div>
                  )}
                </>
              )}

              {(modo === "login" || modo === "registro" || modo === "olvide") && (
                <div>
                  <label style={labelStyle}>Email</label>
                  <input type="email" value={form.email} onChange={e=>set("email", e.target.value)}
                    placeholder="tu@estudio.com" style={inputStyle} required/>
                </div>
              )}

              {(modo === "login" || modo === "registro") && (
                <div>
                  <label style={labelStyle}>Contraseña</label>
                  <input type="password" value={form.password} onChange={e=>set("password", e.target.value)}
                    placeholder="••••••••" style={inputStyle} required minLength={6}/>
                </div>
              )}

              {modo === "resetear" && (
                <>
                  <div>
                    <label style={labelStyle}>Nueva contraseña</label>
                    <input type="password" value={form.passwordNueva} onChange={e=>set("passwordNueva", e.target.value)}
                      placeholder="••••••••" style={inputStyle} required minLength={6}/>
                  </div>
                  <div>
                    <label style={labelStyle}>Confirmar nueva contraseña</label>
                    <input type="password" value={form.passwordNuevaConfirmar} onChange={e=>set("passwordNuevaConfirmar", e.target.value)}
                      placeholder="••••••••" style={inputStyle} required minLength={6}/>
                  </div>
                </>
              )}

              {modo === "login" && (
                <button type="button" onClick={()=>cambiarModo("olvide")}
                  style={{background:"none",border:"none",color:C.grisAzul,fontSize:12.5,cursor:"pointer",fontFamily:"'Inter',sans-serif",textAlign:"right",padding:0,fontWeight:500}}>
                  ¿Olvidaste tu contraseña?
                </button>
              )}

              {error && (
                <div style={{
                  background:C.dangerBg, border:`1px solid ${C.danger}33`,
                  borderRadius:10, padding:"11px 14px", fontSize:13, color:C.danger
                }}>
                  ⚠ {error}
                </div>
              )}

              <button type="submit" disabled={cargando} style={{
                background:C.verde, color:"#fff", border:"none",
                borderRadius:10, padding:"14px", fontSize:15, fontWeight:700,
                cursor:cargando?"not-allowed":"pointer", marginTop:6,
                display:"flex", alignItems:"center", justifyContent:"center", gap:8,
                opacity:cargando?0.65:1, transition:"opacity 0.15s, transform 0.1s",
                fontFamily:"'Inter',sans-serif", boxShadow:`0 4px 14px ${C.verde}40`,
              }}
                onMouseDown={e=>{if(!cargando)e.currentTarget.style.transform="scale(0.98)";}}
                onMouseUp={e=>{e.currentTarget.style.transform="scale(1)";}}>
                {cargando && (
                  <div style={{width:15,height:15,border:"2px solid rgba(255,255,255,0.35)",borderTopColor:"#fff",borderRadius:"50%",animation:"spin 0.7s linear infinite"}}/>
                )}
                {textoBoton[modo]}
              </button>
            </form>
          )}

          <div style={{textAlign:"center", marginTop:24, fontSize:13.5, color:C.inkDim}}>
            {modo === "login" && (
              <>¿No tenés cuenta? <button onClick={()=>cambiarModo("registro")} style={{background:"none",border:"none",color:C.verde,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:13.5}}>Creá una acá</button></>
            )}
            {modo === "registro" && (
              <>¿Ya tenés cuenta? <button onClick={()=>cambiarModo("login")} style={{background:"none",border:"none",color:C.verde,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:13.5}}>Iniciá sesión</button></>
            )}
            {(modo === "olvide" || modo === "resetear") && (
              <>¿Te acordaste? <button onClick={()=>cambiarModo("login")} style={{background:"none",border:"none",color:C.verde,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:13.5}}>Iniciá sesión</button></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
